
export default {
    name: 'rapport-report-reliquat',
    components: {},
    props: {
        rapport_report_reliquats: Array,
        modal_toggler: Number
    },
    data () {
        return {
            fields: [
                { key: 'no', label: 'N°' },
                { key: 'ref', label: 'Référence' }, "date", { key: 'user', label: 'Caissier(e)' },
                { key: 'libelle', label: 'Libellé' }, "patient", { key: 'montant_du', label: 'Montant dû' },
                { key: 'especes_recues', label: 'Espèces reçues' }, { key: 'montant', label: 'Reliquat reporté' }
            ],
           
            filter: "",
            perPage: -1,
            print_per_page: -1,
            currentPage: 1,
            total_pages: 0,
            reliquat_len: 0,
        }
    },

    watch: {
        modal_toggler() {
            this.refreshReportReliquat()
        }
    },

    computed: {

    },

    mounted () {

    },

    methods: {
        refreshReportReliquat() {
            if (this.rapport_report_reliquats) {
                this.reliquat_len = this.rapport_report_reliquats.length
            }
        }
    }
}